#!/usr/bin/env node

// @ts-nocheck
// @ts-ignore
import { existsSync, mkdirSync, writeFileSync } from 'fs';
import { join, resolve } from 'path';
import chalk from 'chalk';

interface CreateConfig {
  projectName: string;
  template: string;
  directory: string;
}

interface Template {
  name: string;
  description: string;
  files: Record<string, string>;
}

// Definir templates como constantes separadas para evitar conflictos de TypeScript
const basicTemplate: any = {
  name: 'basic',
  description: 'Template básico con página principal y about',
  files: {
      'package.json': `{
  "name": "{{projectName}}",
  "version": "1.0.0",
  "description": "Aplicación creada con rowiejs",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "npx --package ../rowiejs-0.4.4.tgz rowiejs build",
    "start": "npx --package ../rowiejs-0.4.4.tgz rowiejs start"
  },
  "dependencies": {
    "react": "^19.2.0",
    "react-dom": "^19.2.0",
    "react-router-dom": "^7.9.3",
    "rowiejs": "^0.4.4"
  },
  "devDependencies": {
    "@types/react": "^19.1.16",
    "@types/react-dom": "^19.0.0-rc.1",
    "typescript": "^5.9.0",
    "tsx": "^4.20.6",
    "@vitejs/plugin-react": "^5.0.4",
    "vite": "^7.1.7"
  }
}`,
      'tsconfig.json': `{
  "compilerOptions": {
    "target": "ES2020",
    "useDefineForClassFields": true,
    "lib": ["ES2020", "DOM", "DOM.Iterable"],
    "module": "ESNext",
    "skipLibCheck": true,
    "moduleResolution": "bundler",
    "allowImportingTsExtensions": true,
    "resolveJsonModule": true,
    "isolatedModules": true,
    "noEmit": true,
    "jsx": "react-jsx",
    "strict": true,
    "noUnusedLocals": true,
    "noUnusedParameters": true,
    "noFallthroughCasesInSwitch": true
  },
  "include": ["app/**/*"],
  "references": [{ "path": "./tsconfig.node.json" }]
}`,
      'tsconfig.node.json': `{
  "compilerOptions": {
    "composite": true,
    "skipLibCheck": true,
    "module": "ESNext",
    "moduleResolution": "bundler",
    "allowSyntheticDefaultImports": true
  },
  "include": ["vite.config.ts"]
}`,
      'vite.config.ts': `import { defineConfig } from 'vite';
import react from '@vitejs/plugin-react';

export default defineConfig({
  plugins: [react()],
  server: {
    port: 3000,
    host: true
  }
});`,
      'app/index.tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

export default function Home() {
  useSEO({
    title: '{{projectName}} - Inicio',
    description: 'Aplicación creada con rowiejs',
    keywords: ['react', 'rowiejs', 'ssr', 'ssg']
  });

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ color: '#2563eb', fontSize: '3rem', marginBottom: '1rem' }}>
          🚀 {{projectName}}
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#6b7280' }}>
          Aplicación creada con rowiejs
        </p>
      </header>

      <main style={{ maxWidth: '800px', margin: '0 auto' }}>
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            ✨ Características
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🛣️ Enrutado Automático</h3>
              <p style={{ color: '#6b7280' }}>File-based routing basado en la estructura de carpetas</p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🔍 SEO Real</h3>
              <p style={{ color: '#6b7280' }}>Meta tags dinámicos con SSR/SSG</p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>⚡ Performance</h3>
              <p style={{ color: '#6b7280' }}>Múltiples modos de renderizado</p>
            </div>
          </div>
        </section>

        <section style={{ textAlign: 'center' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🚀 Comenzar
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '2rem' }}>
            Edita <code style={{ background: '#f3f4f6', padding: '0.25rem 0.5rem', borderRadius: '4px' }}>app/index.tsx</code> para personalizar tu aplicación
          </p>
          <Link 
            to="/about" 
            style={{ 
              display: 'inline-block',
              background: '#2563eb', 
              color: 'white', 
              padding: '0.75rem 1.5rem', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontWeight: 'bold'
            }}
          >
            Ver página About →
          </Link>
        </section>
      </main>
    </div>
  );
}`,
      'app/about.tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

export default function About() {
  useSEO({
    title: '{{projectName}} - Acerca de',
    description: 'Información sobre {{projectName}}',
    keywords: ['about', 'información', 'rowiejs']
  });

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ color: '#2563eb', fontSize: '2.5rem', marginBottom: '1rem' }}>
          Acerca de {{projectName}}
        </h1>
        <p style={{ fontSize: '1.1rem', color: '#6b7280' }}>
          Información sobre esta aplicación
        </p>
      </header>

      <main style={{ maxWidth: '800px', margin: '0 auto' }}>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🎯 ¿Qué es {{projectName}}?
          </h2>
          <p style={{ color: '#4b5563', lineHeight: '1.6', marginBottom: '1rem' }}>
            Esta es una aplicación creada con <strong>rowiejs</strong>, un meta-framework React 
            de nueva generación que combina la simplicidad de un SPA con el poder de SSR y SSG.
          </p>
          <p style={{ color: '#4b5563', lineHeight: '1.6' }}>
            rowiejs ofrece SEO real, enrutado automático y cero configuración para que te 
            enfoques en el código de negocio, no en la configuración.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🛠️ Tecnologías
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
            <div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px', textAlign: 'center' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>React 19</h3>
              <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>UI Framework</p>
            </div>
            <div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px', textAlign: 'center' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>TypeScript</h3>
              <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Tipado Estricto</p>
            </div>
            <div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px', textAlign: 'center' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>Vite</h3>
              <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Build Tool</p>
            </div>
            <div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px', textAlign: 'center' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>rowiejs</h3>
              <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Meta-framework</p>
            </div>
          </div>
        </section>

        <section style={{ textAlign: 'center' }}>
          <Link 
            to="/" 
            style={{ 
              display: 'inline-block',
              background: '#6b7280', 
              color: 'white', 
              padding: '0.75rem 1.5rem', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontWeight: 'bold'
            }}
          >
            ← Volver al inicio
          </Link>
        </section>
      </main>
    </div>
  );
}`,
      'index.html': `<!DOCTYPE html>
<html lang="es">
  <head>
    <meta charset="UTF-8" />
    <link rel="icon" type="image/svg+xml" href="/vite.svg" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>{{projectName}}</title>
  </head>
  <body>
    <div id="root"></div>
    <script type="module" src="/main.tsx"></script>
  </body>
</html>`,
      'main.tsx': `// ⚠️  ARCHIVO GENERADO AUTOMÁTICAMENTE - NO EDITAR MANUALMENTE ⚠️
// Este archivo es generado automáticamente por rowiejs y se sobrescribe
// cada vez que se ejecuta el comando de desarrollo o build.
// 
// Para personalizar el comportamiento de la aplicación, edita los archivos
// en la carpeta 'app/' en lugar de este archivo.
//
// ⚠️  CUALQUIER CAMBIO EN ESTE ARCHIVO SE PERDERÁ ⚠️

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Auto-importar todos los componentes de las páginas
const pages = import.meta.glob('./app/**/*.tsx', { eager: true });

function App() {
  const routes = Object.entries(pages).map(([path, module]) => {
    const component = (module as any).default;
    const routePath = path
      .replace('./app/', '/')
      .replace('.tsx', '')
      .replace('/index', '/')
      .replace(/\\[([^\\]]+)\\]/g, ':$1'); // Convertir [id] a :id
    
    return (
      <Route 
        key={routePath} 
        path={routePath} 
        element={React.createElement(component)} 
      />
    );
  });

  return (
    <BrowserRouter>
      <Routes>
        {routes}
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);`,
      '.vscode/settings.json': `{
  "files.exclude": {
    "main.tsx": true,
    "**/main.tsx": true
  },
  "search.exclude": {
    "main.tsx": true,
    "**/main.tsx": true
  },
  "files.watcherExclude": {
    "main.tsx": true,
    "**/main.tsx": true
  }
}`,
      '.gitignore': `# Dependencies
node_modules/
npm-debug.log*
yarn-debug.log*
yarn-error.log*

# Build outputs
dist/
*.tgz

# Environment variables
.env
.env.local
.env.development.local
.env.test.local
.env.production.local

# IDE
.vscode/
.idea/
*.swp
*.swo

# OS
.DS_Store
Thumbs.db

# Logs
logs
*.log

# Runtime data
pids
*.pid
*.seed
*.pid.lock

# Coverage directory used by tools like istanbul
coverage/

# nyc test coverage
.nyc_output

# Dependency directories
jspm_packages/

# Optional npm cache directory
.npm

# Optional REPL history
.node_repl_history

# Output of 'npm pack'
*.tgz

# Yarn Integrity file
.yarn-integrity

# parcel-bundler cache (https://parceljs.org/)
.cache
.parcel-cache

# next.js build output
.next

# nuxt.js build output
.nuxt

# vuepress build output
.vuepress/dist

# Serverless directories
.serverless

# FuseBox cache
.fusebox/

# DynamoDB Local files
.dynamodb/

# TernJS port file
.tern-port

# rowiejs generated files
main.tsx
**/main.tsx`,
      'app/index.tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ color: '#2563eb', fontSize: '3rem', marginBottom: '1rem' }}>
          🚀 {{projectName}}
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#6b7280' }}>
          Aplicación creada con rowiejs
        </p>
      </header>

      <main style={{ maxWidth: '800px', margin: '0 auto' }}>
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            ✨ Características
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🛣️ Enrutado Automático</h3>
              <p style={{ color: '#6b7280' }}>File-based routing basado en la estructura de carpetas</p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🔍 SEO Real</h3>
              <p style={{ color: '#6b7280' }}>Meta tags dinámicos con SSR/SSG</p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>⚡ Performance</h3>
              <p style={{ color: '#6b7280' }}>Múltiples modos de renderizado</p>
            </div>
          </div>
        </section>

        <section style={{ textAlign: 'center' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🚀 Comenzar
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '2rem' }}>
            Edita <code style={{ background: '#f3f4f6', padding: '0.25rem 0.5rem', borderRadius: '4px' }}>app/index.tsx</code> para personalizar tu aplicación
          </p>
          <Link 
            to="/about" 
            style={{ 
              display: 'inline-block',
              background: '#2563eb', 
              color: 'white', 
              padding: '0.75rem 1.5rem', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontWeight: 'bold'
            }}
          >
            Ver página About →
          </Link>
        </section>

        <section style={{ marginTop: '3rem', padding: '2rem', background: '#f8fafc', borderRadius: '8px' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🛠️ Tecnologías
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
            <div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px', textAlign: 'center' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>React</h3>
              <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>UI Library</p>
            </div>
            <div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px', textAlign: 'center' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>TypeScript</h3>
              <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Tipado Estricto</p>
            </div>
            <div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px', textAlign: 'center' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>Vite</h3>
              <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Build Tool</p>
            </div>
            <div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px', textAlign: 'center' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>rowiejs</h3>
              <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Meta-framework</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}`,
      'app/about.tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ color: '#2563eb', fontSize: '3rem', marginBottom: '1rem' }}>
          📖 Acerca de
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#6b7280' }}>
          Información sobre {{projectName}}
        </p>
      </header>

      <main style={{ maxWidth: '800px', margin: '0 auto' }}>
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🎯 ¿Qué es rowiejs?
          </h2>
          <p style={{ color: '#6b7280', lineHeight: '1.6', marginBottom: '1rem' }}>
            rowiejs es un meta-framework de React que combina lo mejor del SSR, SSG y CSR 
            para crear aplicaciones web modernas y performantes.
          </p>
          <p style={{ color: '#6b7280', lineHeight: '1.6', marginBottom: '1rem' }}>
            Con file-based routing automático, SEO real y múltiples modos de renderizado, 
            rowiejs te permite construir aplicaciones complejas de manera sencilla.
          </p>
        </section>

        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            ✨ Características Principales
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🛣️ Enrutado Automático</h3>
              <p style={{ color: '#6b7280' }}>
                Basado en la estructura de carpetas, sin configuración manual
              </p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🔍 SEO Real</h3>
              <p style={{ color: '#6b7280' }}>
                Meta tags dinámicos con SSR/SSG para mejor posicionamiento
              </p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>⚡ Performance</h3>
              <p style={{ color: '#6b7280' }}>
                Múltiples modos de renderizado según las necesidades
              </p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🎨 TypeScript</h3>
              <p style={{ color: '#6b7280' }}>
                Tipado estricto para mejor experiencia de desarrollo
              </p>
            </div>
          </div>
        </section>

        <section style={{ textAlign: 'center' }}>
          <Link 
            to="/" 
            style={{ 
              display: 'inline-block',
              background: '#6b7280', 
              color: 'white', 
              padding: '0.75rem 1.5rem', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontWeight: 'bold'
            }}
          >
            ← Volver al inicio
          </Link>
        </section>
      </main>
    </div>
  );
}`,
      'app/test.tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

export default function Test() {
  useSEO({
    title: '{{projectName}} - Test',
    description: 'Página de prueba de {{projectName}}',
    keywords: ['test', 'prueba', 'rowiejs']
  });

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ color: '#2563eb', fontSize: '3rem', marginBottom: '1rem' }}>
          🧪 Página de Test
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#6b7280' }}>
          Página de prueba para {{projectName}}
        </p>
      </header>

      <main style={{ maxWidth: '800px', margin: '0 auto' }}>
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🎯 Funcionalidades de Test
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🔄 Hot Reload</h3>
              <p style={{ color: '#6b7280' }}>Cambios se reflejan automáticamente</p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🛣️ Enrutado</h3>
              <p style={{ color: '#6b7280' }}>File-based routing funcionando</p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>⚡ Performance</h3>
              <p style={{ color: '#6b7280' }}>Vite optimizando el desarrollo</p>
            </div>
          </div>
        </section>

        <section style={{ textAlign: 'center' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🚀 Navegación
          </h2>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link 
              to="/" 
              style={{ 
                display: 'inline-block',
                background: '#2563eb', 
                color: 'white', 
                padding: '0.75rem 1.5rem', 
                borderRadius: '8px', 
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              🏠 Home
            </Link>
            <Link 
              to="/about" 
              style={{ 
                display: 'inline-block',
                background: '#059669', 
                color: 'white', 
                padding: '0.75rem 1.5rem', 
                borderRadius: '8px', 
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              📖 About
            </Link>
            <Link 
              to="/test" 
              style={{ 
                display: 'inline-block',
                background: '#dc2626', 
                color: 'white', 
                padding: '0.75rem 1.5rem', 
                borderRadius: '8px', 
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              🧪 Test
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}`,
      'app/test.tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

export default function Test() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ color: '#2563eb', fontSize: '3rem', marginBottom: '1rem' }}>
          🧪 Página de Test
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#6b7280' }}>
          Página de prueba para {{projectName}}
        </p>
      </header>

      <main style={{ maxWidth: '800px', margin: '0 auto' }}>
        <section style={{ marginBottom: '3rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🎯 Funcionalidades de Test
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🔄 Hot Reload</h3>
              <p style={{ color: '#6b7280' }}>Cambios se reflejan automáticamente</p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🛣️ Enrutado</h3>
              <p style={{ color: '#6b7280' }}>File-based routing funcionando</p>
            </div>
            <div style={{ padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <h3 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>⚡ Performance</h3>
              <p style={{ color: '#6b7280' }}>Vite optimizando el desarrollo</p>
            </div>
          </div>
        </section>

        <section style={{ textAlign: 'center' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '1rem' }}>
            🚀 Navegación
          </h2>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link 
              to="/" 
              style={{ 
                display: 'inline-block',
                background: '#2563eb', 
                color: 'white', 
                padding: '0.75rem 1.5rem', 
                borderRadius: '8px', 
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              🏠 Home
            </Link>
            <Link 
              to="/about" 
              style={{ 
                display: 'inline-block',
                background: '#059669', 
                color: 'white', 
                padding: '0.75rem 1.5rem', 
                borderRadius: '8px', 
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              📖 About
            </Link>
            <Link 
              to="/test" 
              style={{ 
                display: 'inline-block',
                background: '#dc2626', 
                color: 'white', 
                padding: '0.75rem 1.5rem', 
                borderRadius: '8px', 
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              🧪 Test
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}`
  }
};


const blogTemplate: any = {
  name: 'blog',
  description: 'Template para blog con posts dinámicos',
  files: {
          'package.json': `{
      "name": "{{projectName}}",
      "version": "1.0.0",
      "description": "Blog creado con rowiejs",
      "type": "module",
      "scripts": {
        "dev": "vite",
        "build": "npx --package ../rowiejs-0.4.4.tgz rowiejs build",
        "start": "npx --package ../rowiejs-0.4.4.tgz rowiejs start"
      },
      "dependencies": {
        "react": "^19.2.0",
        "react-dom": "^19.2.0",
        "react-router-dom": "^7.9.3",
        "rowiejs": "^0.4.4"
      },
      "devDependencies": {
        "@types/react": "^19.1.16",
        "@types/react-dom": "^19.0.0-rc.1",
        "typescript": "^5.9.0",
        "tsx": "^4.20.6",
        "@vitejs/plugin-react": "^5.0.4",
        "vite": "^7.1.7"
      }
    }`,
          'tsconfig.json': `{
      "compilerOptions": {
        "target": "ES2020",
        "useDefineForClassFields": true,
        "lib": ["ES2020", "DOM", "DOM.Iterable"],
        "module": "ESNext",
        "skipLibCheck": true,
        "moduleResolution": "bundler",
        "allowImportingTsExtensions": true,
        "resolveJsonModule": true,
        "isolatedModules": true,
        "noEmit": true,
        "jsx": "react-jsx",
        "strict": true,
        "noUnusedLocals": true,
        "noUnusedParameters": true,
        "noFallthroughCasesInSwitch": true
      },
      "include": ["app/**/*"],
      "references": [{ "path": "./tsconfig.node.json" }]
    }`,
          'tsconfig.node.json': `{
      "compilerOptions": {
        "composite": true,
        "skipLibCheck": true,
        "module": "ESNext",
        "moduleResolution": "bundler",
        "allowSyntheticDefaultImports": true
      },
      "include": ["vite.config.ts"]
    }`,
          'vite.config.ts': `import { defineConfig } from 'vite';
    import react from '@vitejs/plugin-react';

    export default defineConfig({
      plugins: [react()],
      server: {
        port: 3000,
        host: true
      }
    });`,
          'app/index.tsx': `import { useSEO } from 'rowiejs/client';
    import { Link } from 'react-router-dom';

    const posts = [
      {
        id: 'primer-post',
        title: 'Bienvenido a {{projectName}}',
        excerpt: 'Este es el primer post de tu blog creado con rowiejs',
        date: '2024-01-15',
        author: 'Admin'
      },
      {
        id: 'rowiejs-tutorial',
        title: 'Tutorial de rowiejs',
        excerpt: 'Aprende a usar rowiejs para crear aplicaciones React modernas',
        date: '2024-01-10',
        author: 'Admin'
      },
      {
        id: 'react-19-features',
        title: 'Nuevas características de React 19',
        excerpt: 'Descubre las últimas mejoras en React 19',
        date: '2024-01-05',
        author: 'Admin'
      }
    ];

    export default function Home() {
      useSEO({
        title: '{{projectName}} - Blog',
        description: 'Blog personal creado con rowiejs',
        keywords: ['blog', 'react', 'rowiejs', 'tutoriales']
      });

      return (
        <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
          <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 style={{ color: '#2563eb', fontSize: '3rem', marginBottom: '1rem' }}>
              📝 {{projectName}}
            </h1>
            <p style={{ fontSize: '1.2rem', color: '#6b7280' }}>
              Blog personal creado con rowiejs
            </p>
          </header>

          <main style={{ maxWidth: '800px', margin: '0 auto' }}>
            <section>
              <h2 style={{ color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
                📚 Últimos Posts
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                {posts.map((post) => (
                  <article 
                    key={post.id}
                    style={{ 
                      padding: '1.5rem', 
                      border: '1px solid #e5e7eb', 
                      borderRadius: '12px',
                      background: 'white',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                    }}
                  >
                    <div style={{ marginBottom: '1rem' }}>
                      <h3 style={{ 
                        color: '#1f2937', 
                        marginBottom: '0.5rem',
                        fontSize: '1.25rem'
                      }}>
                        <Link 
                          to={\`/blog/\${post.id}\`}
                          style={{ 
                            color: 'inherit', 
                            textDecoration: 'none',
                            ':hover': { color: '#2563eb' }
                          }}
                        >
                          {post.title}
                        </Link>
                      </h3>
                      <div style={{ 
                        display: 'flex', 
                        gap: '1rem', 
                        fontSize: '0.875rem', 
                        color: '#6b7280',
                        marginBottom: '0.75rem'
                      }}>
                        <span>📅 {post.date}</span>
                        <span>👤 {post.author}</span>
                      </div>
                    </div>
                    <p style={{ color: '#4b5563', lineHeight: '1.6', marginBottom: '1rem' }}>
                      {post.excerpt}
                    </p>
                    <Link 
                      to={\`/blog/\${post.id}\`}
                      style={{ 
                        color: '#2563eb', 
                        textDecoration: 'none',
                        fontWeight: 'bold',
                        fontSize: '0.9rem'
                      }}
                    >
                      Leer más →
                    </Link>
                  </article>
                ))}
              </div>
            </section>
          </main>
        </div>
      );
    }`,
          'app/blog/index.tsx': `import { useSEO } from 'rowiejs/client';
    import { Link } from 'react-router-dom';

    const posts = [
      {
        id: 'primer-post',
        title: 'Bienvenido a {{projectName}}',
        excerpt: 'Este es el primer post de tu blog creado con rowiejs',
        date: '2024-01-15',
        author: 'Admin',
        category: 'General'
      },
      {
        id: 'rowiejs-tutorial',
        title: 'Tutorial de rowiejs',
        excerpt: 'Aprende a usar rowiejs para crear aplicaciones React modernas',
        date: '2024-01-10',
        author: 'Admin',
        category: 'Tutorial'
      },
      {
        id: 'react-19-features',
        title: 'Nuevas características de React 19',
        excerpt: 'Descubre las últimas mejoras en React 19',
        date: '2024-01-05',
        author: 'Admin',
        category: 'React'
      }
    ];

    export default function BlogIndex() {
      useSEO({
        title: 'Blog - {{projectName}}',
        description: 'Todos los posts del blog {{projectName}}',
        keywords: ['blog', 'posts', 'artículos', 'rowiejs']
      });

      return (
        <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
          <header style={{ marginBottom: '3rem' }}>
            <Link 
              to="/" 
              style={{ 
                color: '#6b7280', 
                textDecoration: 'none',
                fontSize: '0.9rem',
                marginBottom: '1rem',
                display: 'inline-block'
              }}
            >
              ← Volver al inicio
            </Link>
            <h1 style={{ color: '#2563eb', fontSize: '2.5rem', marginBottom: '1rem' }}>
              📚 Blog
            </h1>
            <p style={{ fontSize: '1.1rem', color: '#6b7280' }}>
              Todos los posts y artículos
            </p>
          </header>

          <main style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              {posts.map((post) => (
                <article 
                  key={post.id}
                  style={{ 
                    padding: '1.5rem', 
                    border: '1px solid #e5e7eb', 
                    borderRadius: '12px',
                    background: 'white',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                  }}
                >
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'flex-start',
                      marginBottom: '0.75rem'
                    }}>
                      <h2 style={{ 
                        color: '#1f2937', 
                        margin: 0,
                        fontSize: '1.5rem'
                      }}>
                        <Link 
                          to={\`/blog/\${post.id}\`}
                          style={{ 
                            color: 'inherit', 
                            textDecoration: 'none'
                          }}
                        >
                          {post.title}
                        </Link>
                      </h2>
                      <span style={{ 
                        background: '#f3f4f6', 
                        color: '#374151', 
                        padding: '0.25rem 0.75rem', 
                        borderRadius: '20px',
                        fontSize: '0.75rem',
                        fontWeight: 'bold'
                      }}>
                        {post.category}
                      </span>
                    </div>
                    <div style={{ 
                      display: 'flex', 
                      gap: '1rem', 
                      fontSize: '0.875rem', 
                      color: '#6b7280',
                      marginBottom: '0.75rem'
                    }}>
                      <span>📅 {post.date}</span>
                      <span>👤 {post.author}</span>
                    </div>
                  </div>
                  <p style={{ color: '#4b5563', lineHeight: '1.6', marginBottom: '1rem' }}>
                    {post.excerpt}
                  </p>
                  <Link 
                    to={\`/blog/\${post.id}\`}
                    style={{ 
                      color: '#2563eb', 
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      fontSize: '0.9rem'
                    }}
                  >
                    Leer más →
                  </Link>
                </article>
              ))}
            </div>
          </main>
        </div>
      );
    }`,
          'app/blog/[slug].tsx': `import { useSEO } from 'rowiejs/client';
    import { Link } from 'react-router-dom';

    // Simulación de datos de posts
    const postsData: Record<string, any> = {
      'primer-post': {
        title: 'Bienvenido a {{projectName}}',
        content: \`# Bienvenido a tu nuevo blog

    ¡Felicidades! Has creado tu blog con **rowiejs**, un meta-framework React de nueva generación.

    ## ¿Qué es rowiejs?

    rowiejs combina la simplicidad de un SPA con el poder de SSR y SSG para ofrecer:

    - ✅ **SEO real** con meta tags dinámicos
    - ✅ **Enrutado automático** basado en archivos
    - ✅ **Zero configuración** para máxima productividad
    - ✅ **Performance extrema** con Vite + React 19

    ## Comenzar a escribir

    Para crear un nuevo post, simplemente:

    1. Crea un archivo en \`app/blog/[slug].tsx\`
    2. Usa el hook \`useSEO\` para los meta tags
    3. Escribe tu contenido en JSX

    ¡Es así de simple!

    ## Próximos pasos

    - Personaliza el diseño en los archivos de la carpeta \`app/\`
    - Agrega más posts dinámicos
    - Configura el SEO para cada página
    - Despliega tu blog

    ¡Disfruta creando con rowiejs! 🚀\`,
        date: '2024-01-15',
        author: 'Admin',
        category: 'General'
      },
      'rowiejs-tutorial': {
        title: 'Tutorial de rowiejs',
        content: \`# Tutorial completo de rowiejs

    En este tutorial aprenderás a usar rowiejs para crear aplicaciones React modernas.

    ## Instalación

    \`\`\`bash
    npm install rowiejs
    \`\`\`

    ## Estructura básica

    \`\`\`
    mi-app/
    ├── app/
    │   ├── index.tsx
    │   └── about.tsx
    ├── package.json
    └── tsconfig.json
    \`\`\`

    ## Crear páginas

    Cada archivo en \`app/\` se convierte automáticamente en una ruta:

    - \`app/index.tsx\` → \`/\`
    - \`app/about.tsx\` → \`/about\`
    - \`app/blog/[slug].tsx\` → \`/blog/:slug\`

    ## SEO automático

    \`\`\`tsx
    import { useSEO } from 'rowiejs/client';

    export default function MyPage() {
      useSEO({
        title: 'Mi Página',
        description: 'Descripción de la página'
      });

      return <h1>Mi Página</h1>;
    }
    \`\`\`

    ## Comandos disponibles

    - \`rowiejs dev\` - Servidor de desarrollo
    - \`rowiejs build\` - Build para producción
    - \`rowiejs start\` - Servidor SSR

    ¡Y eso es todo! rowiejs se encarga del resto. 🎉\`,
        date: '2024-01-10',
        author: 'Admin',
        category: 'Tutorial'
      },
      'react-19-features': {
        title: 'Nuevas características de React 19',
        content: \`# React 19: Las nuevas características

    React 19 trae muchas mejoras emocionantes para los desarrolladores.

    ## Nuevas características principales

    ### 1. Server Components
    Los Server Components permiten renderizar componentes en el servidor:

    \`\`\`tsx
    async function ServerComponent() {
      const data = await fetch('https://api.example.com/data');
      return <div>{data.title}</div>;
    }
    \`\`\`

    ### 2. Actions
    Las Actions simplifican el manejo de formularios:

    \`\`\`tsx
    async function submitForm(formData: FormData) {
      'use server';
      // Lógica del servidor
    }

    function MyForm() {
      return (
        <form action={submitForm}>
          <input name="title" />
          <button type="submit">Enviar</button>
        </form>
      );
    }
    \`\`\`

    ### 3. use Hook
    El nuevo hook \`use\` para manejar promesas:

    \`\`\`tsx
    function MyComponent() {
      const data = use(fetchData());
      return <div>{data}</div>;
    }
    \`\`\`

    ## Compatibilidad con rowiejs

    rowiejs está completamente compatible con React 19 y aprovecha todas estas nuevas características para ofrecer la mejor experiencia de desarrollo.

    ## Migración

    Si tienes una aplicación React existente, la migración a React 19 es gradual y no requiere cambios inmediatos en la mayoría de casos.

    ¡React 19 + rowiejs = 🚀!\`,
        date: '2024-01-05',
        author: 'Admin',
        category: 'React'
      }
    };

    export default function BlogPost({ params }: { params: { slug: string } }) {
      const post = postsData[params.slug];

      if (!post) {
        return (
          <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
            <h1 style={{ color: '#ef4444' }}>Post no encontrado</h1>
            <p>El post que buscas no existe.</p>
            <Link to="/blog">← Volver al blog</Link>
          </div>
        );
      }

      useSEO({
        title: \`\${post.title} - {{projectName}}\`,
        description: \`\${post.content.substring(0, 160)}...\`,
        keywords: [post.category.toLowerCase(), 'blog', 'post']
      });

      return (
        <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
          <header style={{ marginBottom: '3rem' }}>
            <Link 
              to="/blog" 
              style={{ 
                color: '#6b7280', 
                textDecoration: 'none',
                fontSize: '0.9rem',
                marginBottom: '1rem',
                display: 'inline-block'
              }}
            >
              ← Volver al blog
            </Link>
            <h1 style={{ color: '#1f2937', fontSize: '2.5rem', marginBottom: '1rem' }}>
              {post.title}
            </h1>
            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              fontSize: '0.9rem', 
              color: '#6b7280',
              marginBottom: '2rem'
            }}>
              <span>📅 {post.date}</span>
              <span>👤 {post.author}</span>
              <span>🏷️ {post.category}</span>
            </div>
          </header>

          <main style={{ maxWidth: '800px', margin: '0 auto' }}>
            <article style={{ 
              lineHeight: '1.7',
              color: '#374151'
            }}>
              <div style={{ 
                whiteSpace: 'pre-line',
                fontSize: '1.1rem'
              }}>
                {post.content}
              </div>
            </article>
          </main>
        </div>
      );
    }`
  }
};

const ecommerceTemplate: any = {
  name: 'ecommerce',
  description: 'Template para tienda online con productos',
  files: {
      'package.json': `{
  "name": "{{projectName}}",
  "version": "1.0.0",
  "description": "Tienda online creada con rowiejs",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "npx --package ../rowiejs-0.4.4.tgz rowiejs build",
    "start": "npx --package ../rowiejs-0.4.4.tgz rowiejs start"
  },
  "dependencies": {
    "react": "^19.2.0",
    "react-dom": "^19.2.0",
    "react-router-dom": "^7.9.3",
    "rowiejs": "^0.4.4"
  },
  "devDependencies": {
    "@types/react": "^19.1.16",
    "@types/react-dom": "^19.0.0-rc.1",
    "typescript": "^5.9.0",
    "tsx": "^4.20.6",
    "@vitejs/plugin-react": "^5.0.4",
    "vite": "^7.1.7"
  }
}`,
      'tsconfig.json': `{
  "compilerOptions": {
    "target": "ES2020",
    "useDefineForClassFields": true,
    "lib": ["ES2020", "DOM", "DOM.Iterable"],
    "module": "ESNext",
    "skipLibCheck": true,
    "moduleResolution": "bundler",
    "allowImportingTsExtensions": true,
    "resolveJsonModule": true,
    "isolatedModules": true,
    "noEmit": true,
    "jsx": "react-jsx",
    "strict": true,
    "noUnusedLocals": true,
    "noUnusedParameters": true,
    "noFallthroughCasesInSwitch": true
  },
  "include": ["app/**/*"],
  "references": [{ "path": "./tsconfig.node.json" }]
}`,
      'tsconfig.node.json': `{
  "compilerOptions": {
    "composite": true,
    "skipLibCheck": true,
    "module": "ESNext",
    "moduleResolution": "bundler",
    "allowSyntheticDefaultImports": true
  },
  "include": ["vite.config.ts"]
}`,
      'vite.config.ts': `import { defineConfig } from 'vite';
import react from '@vitejs/plugin-react';

export default defineConfig({
  plugins: [react()],
  server: {
    port: 3000,
    host: true
  }
});`,
      'app/index.tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

const featuredProducts = [
  {
    id: 'laptop-pro',
    name: 'Laptop Pro 15"',
    price: 1299.99,
    image: 'https://via.placeholder.com/300x200?text=Laptop+Pro',
    rating: 4.8,
    reviews: 124
  },
  {
    id: 'wireless-headphones',
    name: 'Auriculares Inalámbricos',
    price: 199.99,
    image: 'https://via.placeholder.com/300x200?text=Headphones',
    rating: 4.6,
    reviews: 89
  },
  {
    id: 'smart-watch',
    name: 'Smart Watch Series 5',
    price: 399.99,
    image: 'https://via.placeholder.com/300x200?text=Smart+Watch',
    rating: 4.7,
    reviews: 156
  }
];

export default function Home() {
  useSEO({
    title: '{{projectName}} - Tienda Online',
    description: 'Descubre los mejores productos en {{projectName}}',
    keywords: ['tienda', 'productos', 'compras', 'ecommerce']
  });

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h1 style={{ color: '#2563eb', fontSize: '3rem', marginBottom: '1rem' }}>
          🛒 {{projectName}}
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#6b7280' }}>
          Tu tienda online de confianza
        </p>
      </header>

      <main style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={{ color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
            ⭐ Productos Destacados
          </h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '2rem' 
          }}>
            {featuredProducts.map((product) => (
              <div 
                key={product.id}
                style={{ 
                  background: 'white',
                  borderRadius: '12px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  overflow: 'hidden',
                  transition: 'transform 0.2s'
                }}
              >
                <img 
                  src={product.image} 
                  alt={product.name}
                  style={{ 
                    width: '100%', 
                    height: '200px', 
                    objectFit: 'cover' 
                  }}
                />
                <div style={{ padding: '1.5rem' }}>
                  <h3 style={{ 
                    color: '#1f2937', 
                    marginBottom: '0.5rem',
                    fontSize: '1.25rem'
                  }}>
                    {product.name}
                  </h3>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '1rem' 
                  }}>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      marginRight: '1rem'
                    }}>
                      {'★'.repeat(Math.floor(product.rating))}
                      <span style={{ 
                        color: '#6b7280', 
                        marginLeft: '0.5rem',
                        fontSize: '0.9rem'
                      }}>
                        {product.rating} ({product.reviews})
                      </span>
                    </div>
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center' 
                  }}>
                    <span style={{ 
                      fontSize: '1.5rem', 
                      fontWeight: 'bold', 
                      color: '#2563eb' 
                    }}>
                      \${product.price}
                    </span>
                    <Link 
                      to={\`/products/\${product.id}\`}
                      style={{ 
                        background: '#2563eb', 
                        color: 'white', 
                        padding: '0.75rem 1.5rem', 
                        borderRadius: '8px', 
                        textDecoration: 'none',
                        fontWeight: 'bold'
                      }}
                    >
                      Ver Producto
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ textAlign: 'center' }}>
          <Link 
            to="/products" 
            style={{ 
              display: 'inline-block',
              background: '#10b981', 
              color: 'white', 
              padding: '1rem 2rem', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontWeight: 'bold',
              fontSize: '1.1rem'
            }}
          >
            Ver Todos los Productos →
          </Link>
        </section>
      </main>
    </div>
  );
}`,
      'app/products/index.tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 'laptop-pro',
    name: 'Laptop Pro 15"',
    price: 1299.99,
    image: 'https://via.placeholder.com/300x200?text=Laptop+Pro',
    rating: 4.8,
    reviews: 124,
    category: 'Electrónicos'
  },
  {
    id: 'wireless-headphones',
    name: 'Auriculares Inalámbricos',
    price: 199.99,
    image: 'https://via.placeholder.com/300x200?text=Headphones',
    rating: 4.6,
    reviews: 89,
    category: 'Audio'
  },
  {
    id: 'smart-watch',
    name: 'Smart Watch Series 5',
    price: 399.99,
    image: 'https://via.placeholder.com/300x200?text=Smart+Watch',
    rating: 4.7,
    reviews: 156,
    category: 'Wearables'
  },
  {
    id: 'gaming-mouse',
    name: 'Mouse Gaming RGB',
    price: 79.99,
    image: 'https://via.placeholder.com/300x200?text=Gaming+Mouse',
    rating: 4.5,
    reviews: 67,
    category: 'Gaming'
  },
  {
    id: 'mechanical-keyboard',
    name: 'Teclado Mecánico',
    price: 149.99,
    image: 'https://via.placeholder.com/300x200?text=Keyboard',
    rating: 4.9,
    reviews: 203,
    category: 'Gaming'
  },
  {
    id: 'wireless-charger',
    name: 'Cargador Inalámbrico',
    price: 49.99,
    image: 'https://via.placeholder.com/300x200?text=Wireless+Charger',
    rating: 4.3,
    reviews: 45,
    category: 'Accesorios'
  }
];

export default function ProductsIndex() {
  useSEO({
    title: 'Productos - {{projectName}}',
    description: 'Catálogo completo de productos en {{projectName}}',
    keywords: ['productos', 'catálogo', 'compras', 'tienda']
  });

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ marginBottom: '3rem' }}>
        <Link 
          to="/" 
          style={{ 
            color: '#6b7280', 
            textDecoration: 'none',
            fontSize: '0.9rem',
            marginBottom: '1rem',
            display: 'inline-block'
          }}
        >
          ← Volver al inicio
        </Link>
        <h1 style={{ color: '#2563eb', fontSize: '2.5rem', marginBottom: '1rem' }}>
          🛍️ Productos
        </h1>
        <p style={{ fontSize: '1.1rem', color: '#6b7280' }}>
          Catálogo completo de productos
        </p>
      </header>

      <main style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
          gap: '2rem' 
        }}>
          {products.map((product) => (
            <div 
              key={product.id}
              style={{ 
                background: 'white',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                transition: 'transform 0.2s'
              }}
            >
              <img 
                src={product.image} 
                alt={product.name}
                style={{ 
                  width: '100%', 
                  height: '200px', 
                  objectFit: 'cover' 
                }}
              />
              <div style={{ padding: '1.5rem' }}>
                <div style={{ 
                  background: '#f3f4f6', 
                  color: '#374151', 
                  padding: '0.25rem 0.75rem', 
                  borderRadius: '20px',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  display: 'inline-block',
                  marginBottom: '0.75rem'
                }}>
                  {product.category}
                </div>
                <h3 style={{ 
                  color: '#1f2937', 
                  marginBottom: '0.5rem',
                  fontSize: '1.25rem'
                }}>
                  {product.name}
                </h3>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  marginBottom: '1rem' 
                }}>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    marginRight: '1rem'
                  }}>
                    {'★'.repeat(Math.floor(product.rating))}
                    <span style={{ 
                      color: '#6b7280', 
                      marginLeft: '0.5rem',
                      fontSize: '0.9rem'
                    }}>
                      {product.rating} ({product.reviews})
                    </span>
                  </div>
                </div>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center' 
                }}>
                  <span style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: 'bold', 
                    color: '#2563eb' 
                  }}>
                    \${product.price}
                  </span>
                  <Link 
                    to={\`/products/\${product.id}\`}
                    style={{ 
                      background: '#2563eb', 
                      color: 'white', 
                      padding: '0.75rem 1.5rem', 
                      borderRadius: '8px', 
                      textDecoration: 'none',
                      fontWeight: 'bold'
                    }}
                  >
                    Ver Detalles
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}`,
      'app/products/[id].tsx': `import { useSEO } from 'rowiejs/client';
import { Link } from 'react-router-dom';

const productsData: Record<string, any> = {
  'laptop-pro': {
    name: 'Laptop Pro 15"',
    price: 1299.99,
    image: 'https://via.placeholder.com/600x400?text=Laptop+Pro',
    rating: 4.8,
    reviews: 124,
    category: 'Electrónicos',
    description: 'Laptop profesional de alto rendimiento con pantalla de 15 pulgadas y procesador de última generación.',
    features: [
      'Pantalla 15.6" 4K',
      'Procesador Intel i7',
      '16GB RAM DDR4',
      '512GB SSD',
      'Tarjeta gráfica dedicada',
      'Batería de 8 horas'
    ],
    specifications: {
      'Pantalla': '15.6" 4K UHD',
      'Procesador': 'Intel Core i7-12700H',
      'Memoria': '16GB DDR4',
      'Almacenamiento': '512GB SSD NVMe',
      'Gráficos': 'NVIDIA RTX 3060',
      'Sistema Operativo': 'Windows 11 Pro'
    }
  },
  'wireless-headphones': {
    name: 'Auriculares Inalámbricos',
    price: 199.99,
    image: 'https://via.placeholder.com/600x400?text=Headphones',
    rating: 4.6,
    reviews: 89,
    category: 'Audio',
    description: 'Auriculares inalámbricos con cancelación de ruido activa y sonido de alta calidad.',
    features: [
      'Cancelación de ruido activa',
      'Sonido Hi-Fi',
      'Batería de 30 horas',
      'Carga rápida USB-C',
      'Control táctil',
      'Conexión Bluetooth 5.0'
    ],
    specifications: {
      'Tipo': 'Over-ear inalámbricos',
      'Conectividad': 'Bluetooth 5.0',
      'Batería': '30 horas de uso',
      'Carga': 'USB-C',
      'Cancelación de ruido': 'Sí',
      'Micrófono': 'Integrado con cancelación de ruido'
    }
  },
  'smart-watch': {
    name: 'Smart Watch Series 5',
    price: 399.99,
    image: 'https://via.placeholder.com/600x400?text=Smart+Watch',
    rating: 4.7,
    reviews: 156,
    category: 'Wearables',
    description: 'Reloj inteligente con monitoreo de salud avanzado y pantalla siempre encendida.',
    features: [
      'Pantalla siempre encendida',
      'Monitoreo de frecuencia cardíaca',
      'GPS integrado',
      'Resistente al agua',
      'Batería de 18 horas',
      'Carga inalámbrica'
    ],
    specifications: {
      'Pantalla': '1.9" Retina LTPO',
      'GPS': 'Sí',
      'Resistencia al agua': '50 metros',
      'Batería': '18 horas',
      'Carga': 'Inalámbrica',
      'Sensores': 'Frecuencia cardíaca, acelerómetro, giroscopio'
    }
  }
};

export default function ProductDetail({ params }: { params: { id: string } }) {
  const product = productsData[params.id];

  if (!product) {
    return (
      <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
        <h1 style={{ color: '#ef4444' }}>Producto no encontrado</h1>
        <p>El producto que buscas no existe.</p>
        <Link to="/products">← Volver a productos</Link>
      </div>
    );
  }

  useSEO({
    title: \`\${product.name} - {{projectName}}\`,
    description: product.description,
    keywords: [product.category.toLowerCase(), 'producto', 'comprar', product.name.toLowerCase()]
  });

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <header style={{ marginBottom: '3rem' }}>
        <Link 
          to="/products" 
          style={{ 
            color: '#6b7280', 
            textDecoration: 'none',
            fontSize: '0.9rem',
            marginBottom: '1rem',
            display: 'inline-block'
          }}
        >
          ← Volver a productos
        </Link>
        <h1 style={{ color: '#1f2937', fontSize: '2.5rem', marginBottom: '1rem' }}>
          {product.name}
        </h1>
        <div style={{ 
          display: 'flex', 
          gap: '1rem', 
          fontSize: '0.9rem', 
          color: '#6b7280',
          marginBottom: '2rem'
        }}>
          <span>🏷️ {product.category}</span>
          <span>⭐ {product.rating} ({product.reviews} reseñas)</span>
        </div>
      </header>

      <main style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: '3rem',
          marginBottom: '3rem'
        }}>
          <div>
            <img 
              src={product.image} 
              alt={product.name}
              style={{ 
                width: '100%', 
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
              }}
            />
          </div>
          <div>
            <div style={{ 
              fontSize: '3rem', 
              fontWeight: 'bold', 
              color: '#2563eb',
              marginBottom: '1rem'
            }}>
              \${product.price}
            </div>
            <p style={{ 
              color: '#4b5563', 
              lineHeight: '1.6',
              fontSize: '1.1rem',
              marginBottom: '2rem'
            }}>
              {product.description}
            </p>
            <button style={{ 
              background: '#10b981', 
              color: 'white', 
              padding: '1rem 2rem', 
              borderRadius: '8px', 
              border: 'none',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              cursor: 'pointer',
              width: '100%',
              marginBottom: '1rem'
            }}>
              🛒 Agregar al Carrito
            </button>
            <button style={{ 
              background: 'transparent', 
              color: '#2563eb', 
              padding: '1rem 2rem', 
              borderRadius: '8px', 
              border: '2px solid #2563eb',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              cursor: 'pointer',
              width: '100%'
            }}>
              ❤️ Agregar a Favoritos
            </button>
          </div>
        </div>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: '3rem' 
        }}>
          <div>
            <h3 style={{ color: '#1f2937', marginBottom: '1rem' }}>
              ✨ Características
            </h3>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0,
              color: '#4b5563'
            }}>
              {product.features.map((feature: string, index: number) => (
                <li key={index} style={{ 
                  padding: '0.5rem 0',
                  borderBottom: '1px solid #f3f4f6'
                }}>
                  ✓ {feature}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 style={{ color: '#1f2937', marginBottom: '1rem' }}>
              📋 Especificaciones
            </h3>
            <div style={{ color: '#4b5563' }}>
              {Object.entries(product.specifications).map(([key, value]) => (
                <div key={key} style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  padding: '0.5rem 0',
                  borderBottom: '1px solid #f3f4f6'
                }}>
                  <span style={{ fontWeight: 'bold' }}>{key}:</span>
                  <span>{value as string}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}`
  }
};

function getTemplate(templateName: string): any {
  switch (templateName) {
    case 'basic':
      return basicTemplate;
    case 'blog':
      return blogTemplate;
    case 'ecommerce':
      return ecommerceTemplate;
    default:
      return null;
  }
}

export async function createProject(config: CreateConfig) {
  const { projectName, template, directory } = config;

  console.log(chalk.blue('🚀 Creando proyecto rowiejs...'));
  console.log(chalk.gray(`📁 Proyecto: ${projectName}`));
  console.log(chalk.gray(`🎨 Template: ${template}`));
  console.log(chalk.gray(`📂 Directorio: ${directory}`));

  // Verificar que el template existe
  const templateData = getTemplate(template);
  if (!templateData) {
    console.error(chalk.red(`❌ Template '${template}' no encontrado`));
    console.log(chalk.yellow('📋 Templates disponibles:'));
    ['basic', 'blog', 'ecommerce'].forEach((key) => {
      const tpl = getTemplate(key);
      if (tpl) {
        console.log(chalk.gray(`  - ${key}: ${tpl.description}`));
      }
    });
    process.exit(1);
  }

  // Crear directorio del proyecto
  const projectPath = resolve(directory, projectName);

  if (existsSync(projectPath)) {
    console.error(chalk.red(`❌ El directorio '${projectName}' ya existe`));
    process.exit(1);
  }

  try {
    mkdirSync(projectPath, { recursive: true });
    console.log(chalk.green(`✅ Directorio creado: ${projectPath}`));

    // Crear archivos del template
    let filesCreated = 0;

    for (const [filePath, content] of Object.entries(templateData.files)) {
      const fullPath = join(projectPath, filePath);
      const dirPath = fullPath.substring(0, fullPath.lastIndexOf('/'));

      // Crear directorio si no existe
      if (!existsSync(dirPath)) {
        mkdirSync(dirPath, { recursive: true });
      }

      // Reemplazar placeholders en el contenido
      const processedContent = content.replace(/\{\{projectName\}\}/g, projectName);

      writeFileSync(fullPath, processedContent);
      filesCreated++;
    }

    console.log(chalk.green(`✅ ${filesCreated} archivos creados`));

    // Mostrar instrucciones
    console.log(chalk.blue('\n🎉 ¡Proyecto creado exitosamente!'));
    console.log(chalk.yellow('\n📋 Próximos pasos:'));
    console.log(chalk.gray(`  cd ${projectName}`));
    console.log(chalk.gray('  npm install'));
    console.log(chalk.gray('  npm run dev'));

    console.log(chalk.yellow('\n🔧 Comandos disponibles:'));
    console.log(chalk.gray('  npm run dev     - Servidor de desarrollo'));
    console.log(chalk.gray('  npm run build   - Build para producción'));
    console.log(chalk.gray('  npm run start   - Servidor SSR'));

    console.log(chalk.blue('\n🚀 ¡Disfruta creando con rowiejs!'));

  } catch (error) {
    console.error(chalk.red('❌ Error creando proyecto:'), error);
    process.exit(1);
  }
}
